<app-panel-header-image-view pretitle="{{'Statistics' | transloco}}" title="{{'WorldCupRanking' | transloco}}" banner_image="../../../modules/custom/wa_angular/app/assets/images/banner-world-ranking.jpg"></app-panel-header-image-view>
<app-app-content-page-wrapper>
  <app-wcup-ranking-filters class="app-filters"></app-wcup-ranking-filters>
  <app-wcup-rannking-list class="app-world-ranking-list app-ranking"></app-wcup-rannking-list>
  <hr class="spacer" />
  <div class="block-ads-wrapper">
  <app-wcup-series-panel></app-wcup-series-panel>
  <app-google-ads [type]="'double_click_WA100_2'"></app-google-ads>
</div>
</app-app-content-page-wrapper>
